/** Time intervals, refresh rates and reconnect timings — all in milliseconds. */
export const TIME = {
  // Polling fallbacks (live data primarily arrives via WebSocket)
  TAG_REFRESH_MS: 5_000,
  ALARM_REFRESH_MS: 10_000,
  GATEWAY_REFRESH_MS: 15_000,
  DASHBOARD_REFRESH_MS: 5_000,

  // WebSocket reconnect backoff
  WS_RECONNECT_BASE_MS: 1_000,
  WS_RECONNECT_MAX_MS: 30_000,

  // Auth: refresh silently this long before the access token expires
  SILENT_REFRESH_MS: 300_000,
} as const
